import { Routes, Route } from 'react-router-dom';
import { usePermissions } from '@/hooks/use-permissions';
import { ClientsListPage } from './clients-list-page';
import { ClientCreatePage } from './client-create-page';
import { ClientDetailPage } from './client-detail-page';

export { ClientsListPage } from './clients-list-page';
export { ClientCreatePage } from './client-create-page';
export { ClientDetailPage } from './client-detail-page';

export function ClientsPage() {
  const { canViewClients } = usePermissions();
  // Clients are commercial records restricted to Admins/Managers on the
  // server — say so instead of rendering an empty list off a 403.
  if (!canViewClients) {
    return (
      <div className="p-8 text-center" data-testid="clients-no-access">
        <p className="text-gray-500">
          Clients are only available to Admins and Managers.
        </p>
      </div>
    );
  }
  return (
    <Routes>
      <Route index element={<ClientsListPage />} />
      <Route path="new" element={<ClientCreatePage />} />
      <Route path=":id" element={<ClientDetailPage />} />
    </Routes>
  );
}
